import { websocketHost } from '@/settings';

export default {
  data() {
    return {
      ws: null,
      wsTimer: null,
      wsHeartTime: 10000,
      wsHost: websocketHost, // 默认值
      wsApi: "/api/v2/websocket", // 默认值
      wsParams: {}, // WebSocket 连接参数：key-value 对象

      connect: true, // WebSocket 连接状态：默认自动连接，可通过设置为 false 关闭连接
      closeLimit: 2, // 连接关闭重试次数：避免死循环, false 为不限制
      errorLimit: 2 // 连接错误重试次数：避免死循环, false 为不限制
    };
  },

  computed: {
    wsPath() {
      const protocol = location.protocol === "http:" ? "ws" : "wss";
      const paramStr = Object.keys(this.wsParams)
        .map((key) => `${key}=${this.wsParams[key]}`)
        .join("&");
      return `${protocol}://${this.wsHost}${this.wsApi}${paramStr ? "?" + paramStr : ""}`;
    },
  },

  watch: {
    connect(val) {
      if (val) {
        this.heartCheck();
      } else {
        this.disconnectWebSocket();
      }
    }
  },

  methods: {
    // websocket 心跳检测方法
    heartCheck() {
      if(this.ws?.readyState === 1) { // 如果连接状态为 OPEN 则发送心跳
        this.sendWebSocketMessage({ type: 999 });
      } else {
        if (this.wsTimer) clearTimeout(this.wsTimer);
        this.wsTimer = null;
        this.connectWebSocket();
      }

      this.wsTimer = setTimeout(_ => this.heartCheck(), this.wsHeartTime);
    },

    webSocketOpen() {
      // open success
    },

    webSocketClose() {
      console.log('WebSocket closeLimit', this.closeLimit);
      if (typeof this.closeLimit === 'number' && this.closeLimit <= 0) {
        this.disconnectWebSocket();
        return;
      } else if (typeof this.closeLimit === 'number' && this.closeLimit > 0) {
        this.closeLimit = this.closeLimit - 1;
      }
      this.connectWebSocket();
    },

    webSocketError() {
      console.log('WebSocket errorLimit', this.errorLimit);
      if (typeof this.errorLimit === 'number' && this.errorLimit <= 0) {
        this.disconnectWebSocket();
        return;
      } else if (typeof this.errorLimit === 'number' && this.errorLimit > 0) {
        this.errorLimit = this.errorLimit - 1;
      }
      this.connectWebSocket();
    },

    webSocketMessage(data) {
      console.log('WebSocket message:', data);
    },

    connectWebSocket() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持 WebSocket 实时同步消息，请升级浏览器或更换浏览器后再试！");
        return;
      }

      console.log('WebSocket connecting:', this.wsPath);
      this.connect = true;
      try {
        this.ws = new WebSocket(this.wsPath);
        this.ws.onopen = () => {
          console.log('WebSocket connected');
          this.webSocketOpen();
        };
        this.ws.onmessage = (event) => {
          console.log('WebSocket message received:', event.data);
          try {
            const data = JSON.parse(event.data);
            if (data?.type === 999) return; // 心跳包不处理
            this.webSocketMessage(data);
          } catch (error) {
            console.error('WebSocket message error:', error);
          }
        };
        this.ws.onclose = () => {
          console.log('WebSocket closed');
          this.webSocketClose();
        };
        this.ws.onerror = (error) => {
          console.error('WebSocket error:', error);
          this.webSocketError(error);
        };
      } catch (error) {
        console.error('WebSocket connect error:', error);
      }
    },

    disconnectWebSocket() {
      if (this.ws) this.ws.close();
      if (this.wsTimer) clearTimeout(this.wsTimer);
      this.wsTimer = null;
      this.connect = false;
    },

    sendWebSocketMessage(data) {
      console.log('WebSocket message send:', data);
      const message = typeof data === 'string' ? data : JSON.stringify(data);
      this.ws.send(message);
    },
  },

  created() {
    // 初始化 WebSocket 参数
    this.wsParams = {};
  },

  mounted() {
    // 连接 websocket
    this.connect && this.heartCheck();
  },

  beforeDestroy() {
    this.disconnectWebSocket();
  },
}
